(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9986],{

/***/ 88876:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contacto",
      function () {
        return __webpack_require__(30083);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RemoteImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);






var defaultProps = {
    className: null
};
var propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
var cloudinaryLoader = function(param) {
    var src = param.src;
    if (/^(f|ht)tps?:\/\//i.test(src)) {
        return src;
    }
    return "https://res.cloudinary.com/aibesorg/image/upload/f_auto,q_auto,fl_lossy,f_avif/".concat(src);
};
function RemoteImage(_param) {
    var src = _param.src, alt = _param.alt, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: src,
        alt: alt,
        loader: cloudinaryLoader,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("block h-auto max-w-full", className),
        placeholder: "blur",
        blurDataURL: "data:image/svg+xml;base64,"
    }, rest));
};
RemoteImage.defaultProps = defaultProps;
RemoteImage.propTypes = propTypes;


/***/ }),

/***/ 19296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Paragraph/Paragraph.js





var defaultProps = {
    className: "",
    children: null
};
var propTypes = {
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Paragraph(_param) {
    var className = _param.className, children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, otherProps), {
        children: children
    }));
};
Paragraph.defaultProps = defaultProps;
Paragraph.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Paragraph/index.js

/* harmony default export */ var components_Paragraph = (Paragraph);


/***/ }),

/***/ 86602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Section; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Section/Section.js



var defaultProps = {
    offset: false,
    className: "",
    children: null
};
var propTypes = {
    offset: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Section(param) {
    var offset = param.offset, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (0,clsx_m/* default */.Z)(offset && "py-10 lg:py-16", className),
        children: children
    });
};
Section.defaultProps = defaultProps;
Section.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Section/index.js

/* harmony default export */ var components_Section = (Section);


/***/ }),

/***/ 77276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SubHeading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/DynamicPropsInjection/index.js + 3 modules
var DynamicPropsInjection = __webpack_require__(2183);
// EXTERNAL MODULE: ./src/shapes/index.js + 16 modules
var shapes = __webpack_require__(71634);
;// CONCATENATED MODULE: ./src/components/Spacing/Spacing.js







var defaultProps = {
    horizontal: null,
    vertical: null,
    top: null,
    bottom: null,
    left: null,
    right: null,
    type: "m",
    inject: false,
    className: "",
    children: null
};
var propTypes = {
    horizontal: shapes/* ShapeSpacing */.N0,
    vertical: shapes/* ShapeSpacing */.N0,
    top: shapes/* ShapeSpacing */.N0,
    bottom: shapes/* ShapeSpacing */.N0,
    left: shapes/* ShapeSpacing */.N0,
    right: shapes/* ShapeSpacing */.N0,
    type: prop_types_default().oneOf([
        "m",
        "p"
    ]),
    inject: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Spacing(_param) {
    var horizontal = _param.horizontal, vertical = _param.vertical, top = _param.top, bottom = _param.bottom, left = _param.left, right = _param.right, type = _param.type, inject = _param.inject, className = _param.className, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "horizontal",
        "vertical",
        "top",
        "bottom",
        "left",
        "right",
        "type",
        "inject",
        "className",
        "children"
    ]);
    var classes = [
        className
    ];
    if (horizontal || left === right && left !== null) {
        classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
            "".concat(type, "x-").concat(horizontal || left)
        ]);
    } else {
        if (left !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "l-").concat(left)
            ]);
        }
        if (right !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "r-").concat(right)
            ]);
        }
    }
    if (vertical || top === bottom && top !== null) {
        classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
            "".concat(type, "y-").concat(vertical || top)
        ]);
    } else {
        if (top !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "t-").concat(top)
            ]);
        }
        if (bottom !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "b-").concat(bottom)
            ]);
        }
    }
    var content;
    if (!inject) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: children
        });
    } else {
        content = children;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicPropsInjection/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(classes),
        props: rest,
        children: content
    });
};
Spacing.defaultProps = defaultProps;
Spacing.propTypes = propTypes;


;// CONCATENATED MODULE: ./src/components/Spacing/index.js

/* harmony default export */ var components_Spacing = (Spacing);


// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Text/index.js + 1 modules
var Text = __webpack_require__(37346);
;// CONCATENATED MODULE: ./src/components/SubHeading/SubHeading.js






var SubHeading_defaultProps = {
    color: "text-green-500"
};
var SubHeading_propTypes = {
    heading: (prop_types_default()).string.isRequired,
    color: (prop_types_default()).string
};
function SubHeading(param) {
    var heading = param.heading, color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Spacing, {
        bottom: 4,
        inject: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
            padding: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                className: (0,clsx_m/* default */.Z)("inline-flex text-xl font-semibold leading-none tracking-tight", color),
                children: heading
            })
        })
    });
};
SubHeading.defaultProps = SubHeading_defaultProps;
SubHeading.propTypes = SubHeading_propTypes;

;// CONCATENATED MODULE: ./src/components/SubHeading/index.js

/* harmony default export */ var components_SubHeading = (SubHeading);


/***/ }),

/***/ 37346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Text; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(19296);
;// CONCATENATED MODULE: ./src/components/Text/Text.js




var defaultProps = {
    muted: false,
    xsmall: false,
    small: false,
    large: false,
    medium: false,
    semibold: false,
    className: "",
    children: ""
};
var propTypes = {
    muted: (prop_types_default()).bool,
    xsmall: (prop_types_default()).bool,
    small: (prop_types_default()).bool,
    large: (prop_types_default()).bool,
    medium: (prop_types_default()).bool,
    semibold: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Text(param) {
    var muted = param.muted, xsmall = param.xsmall, small = param.small, large = param.large, medium = param.medium, semibold = param.semibold, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(className, {
            "text-gray-500": muted,
            "text-xs": xsmall,
            "text-sm": small,
            "text-lg": large,
            "font-medium": medium,
            "font-semibold": semibold
        }),
        children: children
    });
};
Text.defaultProps = defaultProps;
Text.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Text/index.js

/* harmony default export */ var components_Text = (Text);


/***/ }),

/***/ 30083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Image/RemoteImage.js
var RemoteImage = __webpack_require__(49187);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/SubHeading/index.js + 3 modules
var SubHeading = __webpack_require__(77276);
// EXTERNAL MODULE: ./src/components/Section/index.js + 1 modules
var Section = __webpack_require__(86602);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/TertiaryTitle/TertiaryTitle.js



var defaultProps = {
    level: 3,
    className: null
};
var propTypes = {
    level: prop_types_default().oneOf([
        3,
        4
    ]),
    className: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired
};
function TertiaryTitle(param) {
    var level = param.level, className = param.className, children = param.children;
    var Level = "h".concat(level);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Level, {
        className: (0,clsx_m/* default */.Z)("text-xl font-semibold leading-tight tracking-tight", className),
        children: children
    });
};
TertiaryTitle.defaultProps = defaultProps;
TertiaryTitle.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/TertiaryTitle/index.js

/* harmony default export */ var components_TertiaryTitle = (TertiaryTitle);

// EXTERNAL MODULE: ./src/components/Text/index.js + 1 modules
var Text = __webpack_require__(37346);
;// CONCATENATED MODULE: ./src/domain/Contact/SectionContactLink.js






var SectionContactLink_defaultProps = {};
var SectionContactLink_propTypes = {
    url: (prop_types_default()).string.isRequired,
    title: (prop_types_default()).string.isRequired,
    description: (prop_types_default()).string.isRequired,
    icon: (prop_types_default()).node.isRequired
};
function SectionContactLink(param) {
    var url = param.url, title = param.title, description = param.description, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: url,
        className: "relative block bg-white rounded-lg hover: lg:rounded-xl xl:rounded-2xl",
        children: function(param) {
            var isHovering = param.isHovering;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-10 p-8 rounded-lg shadow-xs",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center mb-6 text-green-500 bg-green-100 rounded-full h-14 w-14",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "relative z-10 w-8 h-auto",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 20 20",
                                    fill: "currentColor",
                                    children: icon
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TertiaryTitle, {
                                level: 3,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                muted: true,
                                className: "mt-4",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("absolute inset-0 z-0 transform rounded-lg bg-white transition duration-300 ease-in-out lg:rounded-xl xl:rounded-2xl", !isHovering && "shadow-lg", isHovering && "scale-105 shadow-xl")
                    })
                ]
            });
        }
    });
};
SectionContactLink.defaultProps = SectionContactLink_defaultProps;
SectionContactLink.propTypes = SectionContactLink_propTypes;

;// CONCATENATED MODULE: ./src/domain/Contact/SectionContactSells.js


function SectionContactSells() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContactLink, {
        url: "/contacto/ventas",
        title: "Contacto de ventas",
        description: "Pregunte acerca de nuestras certificaciones, precios o solicite un asesoramiento personalizado.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Contact/SectionContactTrainers.js


function SectionContactTrainers() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContactLink, {
        url: "/formacion-de-entrenadores-scrum",
        title: "Formaci\xf3n de entrenadores",
        description: "Realiza la aplicaci\xf3n si tienes inter\xe9s en nuestro programa de formaci\xf3n de entrenadores.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Contact/SectionContactConsulting.js


function SectionContactConsulting() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContactLink, {
        url: "/consultoria-y-entrenamiento",
        title: "Asesoramiento empresarial",
        description: "Obtenga informaci\xf3n acerca de nuestro asesoramiento y consultor\xeda empresarial.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            d: "M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z",
            clipRule: "evenodd"
        })
    });
};

;// CONCATENATED MODULE: ./src/domain/Contact/SectionContactLinks.js






function SectionContactLinks() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
        className: "pb-10 lg:pb-20 relative z-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-12 transform -skew-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-0 z-0 right-0 top-0 h-28 bg-gradient-to-r from-green-300 via-green-100 to-green-300 mt-10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-0 z-10 w-full top-0 h-52 bg-gradient-to-r from-green-100 to-transparent -mt-24"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-0 z-10 w-2/4 top-0 h-52 bg-gradient-to-r from-green-200 to-transparent -mt-14"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-0 z-10 w-2/3 top-0 h-20 bg-gradient-to-r from-green-400 to-transparent mt-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                className: "relative z-50",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-1 lg:grid-cols-3 gap-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContactSells, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContactConsulting, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContactTrainers, {})
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/contacto/index.js





function Contact() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white bg-gradient-to-t from-gray-100 to-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute right-0 top-0 z-0 mt-10 -mr-10 h-52 w-1/5 -skew-y-6 transform bg-gradient-to-l from-green-300 to-transparent opacity-50"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute right-0 top-0 z-0 mt-36 h-52 w-1/5 -skew-y-6 transform bg-gradient-to-l from-green-300 to-transparent opacity-50"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                        className: "py-10 lg:py-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-1 space-y-8 lg:grid-cols-12 lg:gap-10 lg:space-y-0 xl:gap-16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative z-20 lg:col-span-6 lg:flex lg:flex-col lg:justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading/* default */.Z, {
                                            heading: "Cont\xe1ctenos"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "space-y-4 lg:space-y-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "text-4xl font-extrabold tracking-tight lg:text-6xl",
                                                    children: "Impulsamos empresas de todos los tama\xf1os"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-lg text-gray-600 lg:pr-20",
                                                    children: "P\xf3ngase en contacto ahora para analizar c\xf3mo podemos ayudarlo a entregar m\xe1s y mejores resultados en la adopci\xf3n de una cultura \xe1gil."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative z-20 space-y-4 lg:col-span-6 lg:flex lg:flex-col lg:items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex transform overflow-hidden rounded-lg bg-gray-100 shadow-2xl lg:rounded-xl xl:rounded-2xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
                                            src: "v1610716308/contacto/imagen-principal_pewumy.webp",
                                            width: 600,
                                            height: 600,
                                            alt: "Cont\xe1ctenos",
                                            className: "h-auto max-w-full rounded-lg lg:rounded-xl xl:rounded-2xl"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContactLinks, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(88876); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);